<template>
    <div class="appmain">
        <el-form ref="form" :rules="rules" :model="form" label-width="80px" v-if="info">
            <el-form-item :label="$t('user.account')" prop="username">
                <el-input v-model="form.username"></el-input>
            </el-form-item>
            <el-form-item :label="$t('user.verificationCode')" prop="code">
                <el-input v-model="form.code">
                    <template slot="append">
                        <span style="cursor:pointer" v-if="textopen" @click="getcode">{{text}}</span>
                        <span v-if="!textopen">{{daojishi}}s</span>
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item :label="$t('user.newPassword')" prop="password">
                <el-input type="password" v-model="form.password"></el-input>
            </el-form-item>
            <el-form-item :label="$t('user.confirmPassword')" prop="cpassword">
                <el-input type="password" v-model="form.cpassword"></el-input>
            </el-form-item>
            <el-form-item label=" ">
                <div class="regbtn" @click="zhaohui">
                    {{$t('user.retrievePassword')}}
                </div>
            </el-form-item>
        </el-form>
        <div v-if="!info">
            <div class="tubiao">
                <i class="el-icon-success"></i>
            </div>
            <div class="title">
                {{$t('user.title')}}
            </div>
            <div class="tishi">
                {{$t('user.futitle')}}
            </div>
            <div class="caozuobtn">
                <div class="mashang" @click="nav('login')">{{$t('user.loginImmediately')}}</div>
                <div class="fanhui" @click="nav('index')">{{$t('user.backHomepage')}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import { forget,getCode } from "@/api/api"; 
export default {
    data() {
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('user.reenter')))
                // password 是表单上绑定的字段
            } else if (value !== this.form.password) {
                callback(new Error(this.$t('user.pwdb')))
            } else {
                callback()
            }
        }
      return {
        textopen:true,
        text:this.$t('getCode'),
        daojishi:59,
        form: {},
        info:true,
        rules: {
            username: [
                { required: true, message: this.$t('login.usermsg'), trigger: "blur" }
            ],
            password: [
                { required: true, message: this.$t('login.pwdmsg'), trigger: "blur" },
                { min: 5, max: 20, message: this.$t('user.mimamsg'), trigger: 'blur' }
            ],
            cpassword:[
                { required: true, validator: validatePass2, trigger: 'blur' }
            ],
            code:[
                { required: true, message: this.$t('login.codemsg'), trigger: "blur" }
            ]
        },
        title:''
      }
    },
    beforeCreate() {
        document.querySelector('body').setAttribute('style', 'background:#ffffff')
    },
    // 在销毁前，将body的style属性删除
    deactivated() {
        document.querySelector('body').removeAttribute('style')
    },
    created () {
        this.title = this.$t('login.forgetPassword')+'-'+this.$t('seo.title')
    },
    metaInfo () {
        return {
        title: this.title,
        meta: [
            {
                name: 'keyWords',
                content: this.$t('seo.keywords')
            },
            {
                name: 'description',
                content: this.$t('seo.description')
            }
        ]
        }
    },
    methods:{
        zhaohui(){
            this.$refs["form"].validate(valid => {
                if (valid) {
                    forget(this.form).then(res=>{
                        sessionStorage.removeItem('userinfo')
                        this.info = false
                    })
                }
            });
        },
        async getcode(){
            let value = this.form.username
            const mailReg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/
            const iphoneReg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
            if(mailReg.test(value) || iphoneReg.test(value)){
                this.textopen = false
                let data = {
                    username:this.form.username
                }
                this.timer = setInterval(()=>{
                    this.daojishi--
                    if(this.daojishi===0){
                        this.daojishi = 60
                        this.textopen = true
                        clearInterval(this.timer)
                    }
                },1000)
                const {data:res} = await getCode(data)
            }else{
                this.$message.error(this.$t('reg.emtail'));
            }
        },
        nav(url){
            this.$router.push('/'+url)
        }
    }
}
</script>
<style lang="scss" scoped>
    .appmain{
        width: 25%;
        margin-top: 5%;
    }
    @media screen and (max-width: 480px) {
        .appmain{
            width: 90%;
        }
    }
    .regbtn{
        width: 100%;
        height: 48px;
        background: #0052D9;
        font-size: 14px;
        color: #fff;
        text-align: center;
        line-height: 48px;
        cursor: pointer;
    }
    .tubiao{
        font-size: 100px;
        text-align: center;
        color: #52C41A;
    }
    .title{
        text-align: center;
        font-size: 24px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 500;
    }
    .tishi{
        text-align: center;
        color: rgba(0, 0, 0, 0.45);
        margin-top: 2%;
    }
    .caozuobtn{
        width: 200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        margin-top: 3%;
        .mashang{
            background: #0052D9;
            width: 88px;
            height: 32px;
            color: #fff;
            cursor: pointer;
        }
        .fanhui{
            background: #FFFFFF;
            width: 88px;
            height: 32px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            color: #000000;
            cursor: pointer;
        }
    }
</style>
<style  scoped>
    .appmain>>>.el-form-item label:after {
        content: " ";
        display: inline-block;
        width: 100%;
    }
 
    .appmain>>>.el-form-item__label {
        text-align: justify;
        height: 20px;
        font-size: 16px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: #333333;
    }
    /* 这里去除必选字段的*,这个符号会造成一定影响,去掉之后我用了li列表进行定位,在前面加上" * ". */
    .appmain>>>.el-form-item.is-required .el-form-item__label:before {
        content: none !important;
    }
</style>